'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { useClientNav } from '@susu/headless-commerce/features/navigation/components/ClientNavProvider'
import classNames from 'classnames'
import type { ReactNode } from 'react'
import styles from './Nav.module.scss'

export type ClientNavProps = {
  children: ReactNode
  className?: string
}

export const ClientNav = ({ children, className }: ClientNavProps) => {
  useSignals()

  const {
    isCardsLoaded,
    isCountrySelectorOpened,
    isCountrySelectorOpenedFromFooter,
    isLanguageSelectorOpened,
    isLanguageSelectorOpenedFromFooter,
    isNavOpened,
    isSearchMenuOpened,
    isSubMenuOpened,
  } = useClientNav()

  const navClass = classNames(
    styles['nav'],
    'nav',
    {
      'nav--opened': isNavOpened.value,
      'nav--cards-loaded': isCardsLoaded.value,
      'nav--search-opened': isSearchMenuOpened.value,
      'nav--country-opened': isCountrySelectorOpened.value,
      'nav--country-footer-opened': isCountrySelectorOpenedFromFooter.value,
      'nav--language-opened': isLanguageSelectorOpened.value,
      'nav--language-footer-opened': isLanguageSelectorOpenedFromFooter.value,
      'nav--submenu-opened':
        Object.keys(isSubMenuOpened.value).length > 0 ||
        isSearchMenuOpened.value ||
        isCountrySelectorOpened.value ||
        isLanguageSelectorOpened.value,
    },
    className,
  )

  return <nav className={navClass}>{children}</nav>
}
